import React from "react";
import styled from "styled-components";
// import { Link } from "react-router-dom";
// import pioneerMainImg from "../assests/images/pioneerMain.png";

const Layout = styled.div`
  margin-top: 10rem;
  display: grid;
  grid-template-rows: repeat(10, 1fr);
  grid-template-columns: repeat(8, 1fr);
`;

const Title = styled.h1`
  color: ${props => props.theme.colorPrimary};
  margin-left: 6rem;
  font-size: ;
  grid-column: 2 / -1;
`;

export const BasePageGrid = props => (
  <Layout>
    <Title>AUDITION FOR SAMPELL PIONEER</Title>
    <div>image</div>
    <div>text</div>
  </Layout>
);



// WEBPACK FOOTER //
// ./src/playground/BasePageGrid.js